import * as React from "react";
import {IconProps} from "@components/Icons/IconTypes";

export const ChevronRightIcon = React.forwardRef<SVGSVGElement, IconProps>(
    ({ size = 16, title, ...props }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 6 11"
                width={size}
                height={size}
                fill="none"
                role="img"
                aria-hidden={title ? undefined : true}
                {...props}
            >
                {title && <title>{title}</title>}
                <path
                    fill="currentColor"
                    d="M.1464.1464a.5.5 0 0 1 .707 0l4.6667 4.6667a.4999.4999 0 0 1 0 .707L.8535 10.1868a.4999.4999 0 1 1-.707-.707l4.3131-4.3132L.1464.8535a.5.5 0 0 1 0-.707Z"
                />
            </svg>
        );
    }
);

ChevronRightIcon.displayName = "ChevronRightIcon";
